import { fmtEUR } from "../lib/auth";
import type { GoalNode } from "../api/client";

/**
 * Subgoal "vessel" tile with a rising-water fill effect.
 * Background fills from bottom up proportional to progress, in brand color.
 */
export default function SubGoalTile({ node }: { node: GoalNode }) {
  const total = Number(node.total);
  const target = Number(node.total_target);
  const pct = target > 0 ? Math.min(100, (total / target) * 100) : 0;
  const reached = total >= target && target > 0;

  return (
    <a
      href="/goals"
      className="group relative block overflow-hidden rounded-xl border border-ink-800 bg-ink-900 p-4 transition hover:border-brand-500"
      title={`${pct.toFixed(1)} %`}
    >
      {/* Water fill */}
      <div
        className="absolute inset-x-0 bottom-0 transition-all duration-700 ease-out"
        style={{
          height: `${pct}%`,
          background: reached
            ? "linear-gradient(180deg, rgba(20,184,166,0.30) 0%, rgba(20,184,166,0.18) 100%)"
            : "linear-gradient(180deg, rgba(20,184,166,0.18) 0%, rgba(20,184,166,0.08) 100%)",
        }}
      />
      {/* Wave */}
      <svg
        className="absolute left-0 right-0 -translate-y-px text-brand-500/35"
        style={{ bottom: `${pct}%`, height: 6, width: "100%" }}
        viewBox="0 0 100 6"
        preserveAspectRatio="none"
      >
        <path
          d="M0 4 Q 12.5 0, 25 4 T 50 4 T 75 4 T 100 4 V6 H0 Z"
          fill="currentColor"
        />
      </svg>

      <div className="relative">
        <div className="flex items-baseline justify-between gap-2">
          <span className="font-medium text-ink-100 group-hover:text-brand-300">
            {node.name}
          </span>
          <span className="text-xs num text-ink-400">{pct.toFixed(0)} %</span>
        </div>
        <div className="mt-1 text-sm num text-ink-200">
          {fmtEUR(total)}
          <span className="text-ink-500"> / {fmtEUR(target)}</span>
        </div>
        {reached && (
          <span className="mt-1 inline-block text-[11px] text-good-500">erreicht ✓</span>
        )}
      </div>
    </a>
  );
}
